import React, { useState, useEffect, useRef } from "react";
import { DateRange } from "../common/helpers/daterange";
import RightArrow from "../common/icons/right-arrow";
import { useTranslation } from 'react-i18next';
import { _Api, Api_form } from "../api/_call";
import { error, loading, success, Updateloading } from "../common/helpers/toastify";
import { Pagination } from "../common/Pagination";
import { useSelector } from 'react-redux';
import TableLoader from "../common/TableLoader";
import * as XLSX from 'xlsx'
import * as FileSaver from 'file-saver'
import Select from "react-select";
import Importmodal from "../common/modules/Importmodal";
import ExportFormatModal from "../common/modules/ExportFormatModal";
import MasterCurrecyEditModal from "../common/modules/MasterCurrecyEditModal";
const MasterCurrency = () => {
  const dropdownRefcurrency = useRef(null);
  const dropdownRefstatus = useRef(null);
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const { t } = useTranslation();
  const [getcurrencylist, setGetcurrencylist] = useState([])
  const [showedit, setShowedit] = useState(false)
  const [filtername, setFiltername] = useState('');
  const [searchVal, setSearchVal] = useState("");
  const [currencychecked, setCurrencychecked] = useState([])
  const [currencyfilterarr, setCurrencyfilterarr] = useState([])
  const [statuschecked, setStatuschecked] = useState("")
  const [statusfilter, setStatusfilter] = useState([])
  const [showloader, setShowloader] = useState(false)
  const [shortobj, setShortobj] = useState({})
  const [exportid, setExportid] = useState([])
  const [limit, setLimit] = useState(100);
  const [importfile, setImportfile] = useState()
  const [exportFormat, setExportFormat] = useState("xlsx")
  const [datefilter, setDatefilter] = useState([]);
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  const filterbyname = (search) => {
    getcurrency(currentPage, limit, search);
    setstate({ ...state, currentPage: 1 });
  };
  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });
  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    getcurrency(current, "");
  };
  const getcurrency = async (current, firstlimit, search) => {
    setShowloader(true);
    if (showedit) {
      setStatuschecked("")
      setCurrencychecked("")
    }
    try {
      var skipNumber = current ? (current - 1) * limit : 0;
      let postdata = {
        "search": search ? search : "",
        "limit": firstlimit ? firstlimit : limit,
        "skip": skipNumber,
        // "filter": {
        //   "status": statuschecked ? statuschecked : "",
        //   "currency": currencychecked ? currencychecked : ""
        // },
        "sort": { [shortobj?.key]: shortobj?.value }
      }
      let res = await _Api(postdata, `api/v1/App/master/currencyMasterList`)
      if (res?.code === 200) {
        setGetcurrencylist(res?.data)
        setShowloader(false);
        setstate({
          ...state,
          totalPages: Math.ceil(res?.total / postdata.limit),
          currentPage: current ? current : 1
        });
      }
    }
    catch (err) {
      console.log(err, "err")
    }
  }

  const getlimit = (limit) => {
    setLimit(limit);
    getcurrency(1, limit);
    setstate({ ...state, currentPage: 1 });
  };



  const currencyfilter = async () => {
    try {
      let postdata = {}
      let res = await _Api(postdata, `api/v1/App/master/currencyfilter`)
      if (res?.code === 200) {
        setCurrencyfilterarr(res?.data?.currency)
        setStatusfilter(res?.data?.status)
      }
    }
    catch (err) {
      console.log(err, "err")
    }
  }

  useEffect(() => {
    setTimeout(()=>{
      getcurrency()
    },1500)
    currencyfilter()
    // eslint-disable-next-line
  }, [showedit, shortobj])

  const hendledropdownhide = (lable) => {
    if (lable === "currency") {
      dropdownRefcurrency.current.classList.remove("show")
    } else if (lable === "status") {
      dropdownRefstatus.current.classList.remove("show")
    }
  }
  const handleCheckAllChange = (e, lable) => {
    if (lable === "currency") {
      setCurrencychecked(
        e.target.checked ? currencyfilterarr.map((c) => c) : []
      );
    } else if (lable === "export") {
      setExportid(
        e.target.checked ? getcurrencylist.map((c) => c?.id) : []
      )
    }

  };
  const handlefilerChange = (event, data, lable) => {
    if (lable === "currency") {
      setCurrencychecked((prevChecked) =>
        event.target.checked
          ? [...prevChecked, data]
          : prevChecked.filter((item) => item !== data)

      );
    } else if (lable === "export") {
      setExportid((prevChecked) =>
        event.target.checked
          ? [...prevChecked, data]
          : prevChecked.filter((item) => item !== data)
      )
    }

  };

  const getscarchvalue = async (event, lable) => {
    if (lable === "currency") {
      const query = searchVal ? searchVal : event.target.value ? event.target.value : "";
      let updatedList = [...currencyfilterarr];
      let arr = []
      if (query) {
        updatedList.forEach((item) => {
          if (item?.toLowerCase() === query.toLowerCase()) {
            arr.push(item)
          }
          setCurrencyfilterarr(arr)
        });
      } else {
        currencyfilter()
      }
    }
  }
  const selectOptions = [
    { label: "100", value: "100" },
    { label: "200", value: "200" },
    { label: "300", value: "300" }
  ]
  // const handleScrollToThetop = () => {
  //   setTimeout(() => {
  //     if (currencyListRef.current) {
  //       currencyListRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //     }
  //   }, 100)
  // }
  const downloadexclsheet = async () => {
    let GetloadingID = loading()
    let header_values = []
    let bodyarray = []
    header_values.push(

      'Currency',
      'ExchangeRate',
      'DefaultCurrency',
      'Status',
    )
    if (getcurrencylist.length) {
      getcurrencylist.forEach((result, key) => {
        bodyarray.push([
          result?.currency,
          result?.exchangeRate,
          result?.is_default,
          result?.Status,
        ])
      })
    }


    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.json_to_sheet(bodyarray, {
      origin: 'A2',
      skipHeader: true,
    });
    // Add header styles (background color, font color, etc.)
    const headerStyle = {
      font: { bold: true, color: { rgb: 'FFFFFF' } }, // White text color
      fill: { fgColor: { rgb: '000000' } }, // Black background color
    };

    // Apply header styles
    header_values.forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
      ws[cellRef] = headerStyle;
    });

    // Set column widths
    const columnWidths = [
      { wch: 20 }, // Width for Header1 column
      { wch: 30 }, // Width for Header2 column
      { wch: 25 }, // Width for Header3 column
    ];
    ws['!cols'] = columnWidths;

    XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: 'A1' })
    XLSX.utils.book_append_sheet(wb, ws, 'MasterCurrency')
    if (exportFormat === "csv") {
      const csvContent = XLSX.write(wb, { bookType: 'csv', type: 'string' })
      FileSaver.saveAs(new Blob([csvContent], { type: 'text/csv;charset=UTF-8' }), 'Master Currency.csv');
    } else {
      const fileContent = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const data = new Blob([fileContent], { type: fileType })
      FileSaver.saveAs(data, 'Master Currency');
    }
    Updateloading(t, GetloadingID, "Master Currency export")
  }

  const readExcel = async () => {
    if (!importfile) {
      error(t('Choose file!'));
      return;
    }
    try {
      let GetloadingID=loading();
      const formData = new FormData()
      formData.append('file', importfile)
      formData.append('type', 'Item')

      let res = await Api_form(
        formData,
        `api/v1/App/Import/currencyImport`,
      )
      if (res.code === 200) {
        // success(
        //   t(res?.message),
        // )
         Updateloading(t,GetloadingID,t(res?.message))
        getcurrency()
      } else {
        // error(t(res?.message))
        Updateloading(t, GetloadingID,t(res?.message), 'error');
      }
    } catch (err) {
      console.log(err, 'err')
    }

  }
  const base_url = process.env.REACT_APP_BASE_ASSETS_URL
  const SampleExcel = () => {
    const exportLinkElement = document.createElement('a')
    exportLinkElement.hidden = true
    exportLinkElement.download = 'MasterCurrency.xlsx'
    exportLinkElement.href = base_url + "master_xlsx/MasterCurrency.xlsx"
    exportLinkElement.text = 'downloading...'
    document.body.appendChild(exportLinkElement)
    exportLinkElement.click()
    exportLinkElement.remove()
  }
    // const userlogrepostlist = async () => {
    //   setShowloader(true)
  
    //   try {
    //     setTimeout(async () => {
      
    //       UnSetdataTable("userlogrepostlist");
    //       const postdata = {
          
    //         "start_date": start,
    //         "end_date":end

    //       };
  
    //       let res = await _Api(postdata, `api/v1/App/master/currencyExport`);
    //       if (res.code === 200) {
    //         // const sortedData = [...res?.data].sort((a, b) => parseDateTime(b.date) - parseDateTime(a.date));
    //         setUserrepostlist(res?.data)
    //         setShowloader(false)
    //         setstate({
    //           ...state,
    //           totalPages: Math.ceil(res?.count / postdata.limit),
    //           currentPage: current ? current : 1
    //         });
    //         SetdataTable("userlogrepostlist", 0, newcolumndata, [0]);
    //       }
    //     }, 100)
    //   }
    //   catch (err) {
    //     SetdataTable("userlogrepostlist", 0, newcolumndata, [0]);
    //     console.log(err, 'err');
    //   }
    // }
    const downloadexclsheethistory=async ()=>{
      const postData={
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : "",
        "format": exportFormat,
      }
     let res = await _Api(postData, `api/v1/App/master/currencyExport`);
     if (res.code === 200) {
      success(
        t(res?.message),
      )
    } else {
      error(t(res?.message))
    }
  }
  return (
    <>
      <div className="main-content-wrapper-body">
        <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
          <div className="main-content-wrapper-body-top-bar-left">
            <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">{t("Master")} <RightArrow /> <span className="cursor-pointer" onClick={() => setShowedit(true)}>{t("Currency")}</span></h1>
          </div>
          <div className="main-content-wrapper-body-top-bar-right d-flex align-items-center">

            <Select
              className="limit-select mx-3"
              options={selectOptions}
              value={{ label: limit, value: limit }}
              onChange={(e) => { setLimit(e.value); getlimit(e.value) }}
            />
            <div className="com-search-bar position-relative">
              <img onClick={filterbyname} className="com-search-bar-search-img" src={base_assets + "images/admin/icons/gray-search.png"} alt="" />
              <input placeholder="Search Currency" value={filtername} className="h-100 border-0 bg-transparent"
                onKeyPress={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                onChange={(e) => setFiltername(e.target.value)} />
              {filtername ? <img className="search-bar-clear" onClick={(e) => {
                setFiltername("");
                getcurrency(1, 100, "")
              }} src={base_assets + 'images/icons/False.png'} alt="" /> : ""}
            </div>
               <div className="main-body-1">
               <DateRange setDatefilter={setDatefilter} />
               </div>
            <div className="print-export-dropdown dropdown">
              <button
                className="btn dropdown-toggle text-center d-flex align-items-center rounded-1 ms-3 justify-content-center bg-white toggle-btn"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img src={base_assets + "images/admin/icons/gray-ellipsis.png"} alt="" />
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                <li className="dropdown-item print-dropdown-item">
                  <div className="dropdown-item-img">
                    <img
                      src={base_assets + "images/icons/printer-icon.png"}
                      alt=""
                    />
                  </div>
                  <span>{t("print")}</span>
                </li>
                <li className="dropdown-item" data-bs-toggle="modal" data-bs-target="#currencyExportFormatModal">
                  <div className="dropdown-item-img">
                    <img
                      src={base_assets + "images/icons/export-x-icon.png"}
                      alt=""
                    />
                  </div>
                  <span>{t("export")}</span>
                </li>
                <li className="dropdown-item" data-bs-toggle="modal" data-bs-target="#currencyHistoryExportFormatModal">
                  <div className="dropdown-item-img">
                    <img
                      src={base_assets + "images/icons/export-x-icon.png"}
                      alt=""
                    />
                  </div>
                  <span>{t("export_history")}</span>
                </li>
                <li className="dropdown-item" data-bs-toggle="modal"
                  data-bs-target="#ImportModal">
                  <div className="dropdown-item-img">
                    <img
                      src={base_assets + "images/icons/export.png"}
                      alt=""
                    />
                  </div>
                  <span >{t("Import")}</span>
                </li>
              </ul>
            </div>
            {parmissiondatashow?.Master?.Edit ?
              <button className={parmissiondatashow?.Master?.Add ? "com-plus-text-btn text-white text-center fw-semibold d-flex align-items-center border-0 rounded-1 ms-3" : "d-none"}
                // onClick={() => { setEditItem(true); setCreate(true); setDataid("") }}
                data-bs-toggle="modal"
                data-bs-target="#MasterCurrecyModal"
              >
                <img className="me-2" src={base_assets + "images/admin/icons/add-icon-white.png"} alt="" />{t("Edit")}
              </button>
              : ""}
          </div>
        </div>
        <div className="row">
          <div className={"col-md-12"}>
            <div
              className="main-body-main-table-wrap com-custom-table table-responsive position-relative"
            >
              <table
                id="my_customer"
                className="com-custom-table-tag table align-middle">
                <thead>
                  <tr className="text-nowrap align-middle">
                    <th className="pe-0">
                      <div className="com-check">
                        <input id="check1" type="checkbox"
                          onChange={(e) => handleCheckAllChange(e, "export")}
                          checked={getcurrencylist?.length ? exportid?.length === getcurrencylist?.length : false} />
                        <label htmlFor="check1" className="com-check-label"
                        />
                      </div>
                    </th>
                    <th>#</th>
                    <th className="px-1"></th>
                    <th className="user-name-width">{t("Currency")}
                      <div className="dropdown d-inline-block com-custom-table-tag-filter">
                        <button className="after-none bg-transparent border-0 dropdown-toggle p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" >
                          <img className="ms-2 com-custom-table-tag-filter-img" src={base_assets + "images/icons/table-filter-icon.png"} alt="" />
                        </button>
                        <div className={"dropdown-menu com-custom-table-tag-filter-menu p-0 border-0 overflow-hidden"}
                          ref={dropdownRefcurrency}>
                          <div className="asc-des-order">
                            <div onClick={() => { setShortobj({ key: "currency", value: 1 }); hendledropdownhide("currency") }} className="asc-des-order-single cursor-pointer"> <img src={base_assets + "images/icons/arrow-sort-up.png"} alt="" /> {t("Sort Ascending")}</div>
                            <div onClick={() => { setShortobj({ key: "currency", value: -1 }); hendledropdownhide("currency") }} className="asc-des-order-single cursor-pointer"> <img src={base_assets + "images/icons/arrow-sort-down.png"} alt="" /> {t("Sort Descending")}</div>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-search">
                            <div className="com-custom-table-tag-filter-menu-search-inner d-flex align-items-center">
                              <img src={base_assets + "images/icons/search-icon.png"} alt="" />
                              <input className="border-0" type="text" placeholder="Search"
                                onKeyPress={(e) => e.key === 'Enter' && getscarchvalue(e, "currency")}
                                onChange={(e) => setSearchVal(e.target.value)} />
                            </div>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-select">
                            <div className="com-custom-table-tag-filter-menu-select-bar d-flex align-items-center justify-content-between">
                              <div>
                                <input className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer" type="checkbox" id="currency"
                                  onChange={(e) => handleCheckAllChange(e, "currency")}
                                  checked={currencychecked.length === currencyfilterarr.length} />
                                <label className="form-check-label cursor-pointer fw-semibold" htmlFor="currency">{t("Select All")}</label>
                              </div>
                              <label>{currencychecked.length}/{currencyfilterarr.length} Selected</label>
                            </div>
                            <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
                              {currencyfilterarr?.length ? currencyfilterarr.map((result, key) => {
                                return (
                                  <li className="com-custom-table-tag-filter-menu-select-list-single" key={key}>
                                    <input className="fill-com-check form-check-input d-inline-block me-2 cursor-pointer" type="checkbox" id={key + "currency"}
                                      checked={
                                        currencychecked ? currencychecked.includes(result) : ""
                                      }
                                      onChange={(e) => handlefilerChange(e, result, "currency")} />
                                    <label className="form-check-label cursor-pointer" htmlFor={key + "currency"}>{result}</label>
                                  </li>
                                )
                              }) : ""}

                            </ul>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2"
                          >
                            <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor"
                              onClick={() => { setCurrencychecked([]); setShortobj({}); hendledropdownhide("currency") }}>{t("Clear")}</button>
                            <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold" onClick={() => { getcurrency(); hendledropdownhide("currency") }}>{t("Apply")}</button>
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>{t("Exchange Rate")}</th>
                    <th>{t("Last Modified Date")} </th>
                    <th>{t("Status")}
                      <div className="dropdown d-inline-block com-custom-table-tag-filter">
                        <button className="after-none bg-transparent border-0 dropdown-toggle p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" >
                          <img className="ms-2 com-custom-table-tag-filter-img" src={base_assets + "images/icons/table-filter-icon.png"} alt="" />
                        </button>
                        <div className="dropdown-menu com-custom-table-tag-filter-menu p-0 border-0 overflow-hidden"
                          ref={dropdownRefstatus}
                        >
                          <div className="asc-des-order">
                            <div onClick={() => { setShortobj({ key: "Status", value: -1 }); hendledropdownhide("status") }} className="asc-des-order-single cursor-pointer"> <img src={base_assets + "images/icons/arrow-sort-up.png"} alt="" /> {t("Sort Ascending")}</div>
                            <div onClick={() => { setShortobj({ key: "Status", value: 1 }); hendledropdownhide("status") }} className="asc-des-order-single cursor-pointer"> <img src={base_assets + "images/icons/arrow-sort-down.png"} alt="" /> {t("Sort Descending")}</div>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-select">
                            <ul className="com-custom-table-tag-filter-menu-select-list list-unstyled mt-3 ps-4">
                              {statusfilter?.length ? statusfilter.map((result, key) => {
                                return (
                                  <li className="com-custom-table-tag-filter-menu-select-list-single" key={key}>
                                    <input className="fill-com-check form-check-input radio d-inline-block me-2 cursor-pointer" name="mixmatchradio" type="radio" id={key + "status"} value={result?.value}
                                      onClick={(e) => setStatuschecked(result?.value)} />
                                    <label className="form-check-label cursor-pointer" htmlFor={key + "status"}>{result?.lable}</label>
                                  </li>
                                )
                              }) : ""}

                            </ul>
                          </div>
                          <div className="com-custom-table-tag-filter-menu-btn-grp text-center d-flex align-items-center gap-2">
                            <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 bg-transparent fw-semibold graythemecolor"
                              onClick={(e) => { setStatuschecked(""); setShortobj({}); hendledropdownhide("status") }} >{t("Clear")}</button>
                            <button className="com-custom-table-tag-filter-menu-btn-grp-single flex-grow-1 main-green-bg text-white fw-semibold" onClick={() => { getcurrency(); hendledropdownhide("status") }}>{t("Apply")}</button>
                          </div>
                        </div>
                      </div>
                    </th>
                    {/* <th></th> */}
                  </tr>
                </thead>
                <tbody>
                  {getcurrencylist?.length ? getcurrencylist.map((result, key) => {
                    return (
                      <tr className="text-nowrap" key={key}>
                        <td className="pe-0">
                          <div className="com-check">
                            <input id={result?.id} type="checkbox"
                              onChange={(e) => handlefilerChange(e, result?.id, "export")}
                              checked={
                                exportid ? exportid.includes(result?.id) : ""
                              } />
                            <label htmlFor={result?.id} className="com-check-label" />
                          </div>
                        </td>
                        <td>{key + 1}</td>
                        <td className="px-1">
                          <img style={{ width: "1.6vw" }} src={base_assets + 'images/square-flags/' + result?.flag} alt="" />
                        </td>
                        {/* {parmissiondatashow?.Master?.Edit ?
                          <td className="link-color cursor-pointer" onClick={() => { setEditItem(true); setDataid(result?.id); setCreate(false); handleScrollToThetop() }}>{result?.currency ? result?.currency : ""}</td> :
                          <td>{result?.currency ? result?.currency : ""}</td>} */}
                        <td>{result?.currency ? result?.currency : ""}</td>
                        <td>{result?.exchangeRate ? result?.exchangeRate : ""}</td>
                        <td>{result?.updated ? result?.updated : ""}</td>
                        <td>
                          {result?.Status === "1" ? <span className="active-badge  rounded-pill px-2 py-1 fw-semibold"> <span className="active-badge-dot me-2"></span>{t("Active")}</span>
                            : <span className="inactive-badge  rounded-pill px-2 py-1 fw-semibold"> <span className="inactive-badge-dot me-2"></span>{t("InActive")}</span>}

                        </td>
                        {/* <td className="text-center">
                          <img
                            onClick={() => { setEditItem(true); setDataid(result?.id); setCreate(false) }}
                            className={parmissiondatashow?.Master?.Edit ? "cursor-pointer me-4" : "d-none"}
                            src={base_assets + "images/admin/icons/Edit.png"} alt="" />
                          <img
                            onClick={() => setDataid(result?.id)} data-bs-toggle="modal" data-bs-target="#createPurchaseModal" className={parmissiondatashow?.Master?.Delete ? "cursor-pointer" : "d-none"}
                            src={base_assets + "images/admin/icons/Delete.png"} alt="" />
                        </td> */}
                      </tr>
                    )
                  }) :
                    <tr>
                      <td colSpan="50" className="text-center"> {t("No Data Available In Table")}</td>
                    </tr>
                  }

                </tbody>
              </table>
              {showloader && <TableLoader />}
            </div>
            {getcurrencylist?.length > 0 ? (
              <Pagination
                total={totalPages}
                current={currentPage}
                pagination={(crPage) => handlePaginations(crPage)}
              />
            ) : (
              ""
            )}
          </div>
          {/* <div className={editItem ? "col-md-6 d-block" : "d-none"} ref={currencyListRef}>
            <EditCurrency setEditItem={setEditItem}
              dataid={dataid}
              setShowedit={setShowedit}
              create={create}
              setDataid={setDataid}
              setCreate={setCreate}
            />
          </div> */}
        </div>
      </div>
      <Importmodal
        setImportfile={setImportfile}
        readExcel={readExcel}
        importfile={importfile}
        SampleExcel={SampleExcel}
        extensions={[".xlsx", ".xls", ".csv"]} />
      <ExportFormatModal
        id="currencyExportFormatModal"
        format={exportFormat}
        setFormat={setExportFormat}
        onExport={downloadexclsheet} />
      <ExportFormatModal
        id="currencyHistoryExportFormatModal"
        format={exportFormat}
        setFormat={setExportFormat}
        onExport={downloadexclsheethistory} />

      <MasterCurrecyEditModal setShowedit={setShowedit}
      />
    </>
  )
}

export default MasterCurrency;